<template>
  <div>
    <el-form-item label="品类" required>
      <el-select class="rule" v-model="categoryCode" placeholder="请选择品类（要先选择品种）" @change="countDeposit">
        <el-option
          v-for="(item, index) in categoryList"
          :key="index"
          :label="item.dictSubValue"
          :value="item.dictSubCode" />
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'category',
  props: {
    code: { // 父组件选择的品种对应的code值
      type: String,
      default: ''
    },
    category: { // 发布报价的时候，从父组件带过来已经选好的品类
      type: String,
      default: ''
    }
  },
  data () {
    return {
      categoryCode: '', // 品类
      categoryList: [], // 列表
    }
  },
  watch: {
    code () {
      this.getCategory() // 获取品类
    },
    categoryCode (val) {
      this.$emit('input', val)
    },
    category (val) {
      this.categoryCode = val
    }
  },
  methods: {
    // 获取品类列表
    getCategory () {
      const url = this.$API.releaseQuotation.basedatadictsub
      const param = {
        currentNo: 1,
        dictCode: this.code,
        dictStatus: '1',
        pageSize: 50
      }
      this.$http.post(url, param).then((res) => {
        this.categoryList = res.data.rows
      })
    },
    // 选择品牌
    countDeposit () {
      this.$emit('countDeposit')
    },
    // 重置数据
    reset () {
      this.categoryCode = ''
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
